"use strict";

// Gesture Handlers
import FlingGestureHandler from './handlers/FlingGestureHandler';
import HoverGestureHandler from './handlers/HoverGestureHandler';
import LongPressGestureHandler from './handlers/LongPressGestureHandler';
import ManualGestureHandler from './handlers/ManualGestureHandler';
import NativeViewGestureHandler from './handlers/NativeViewGestureHandler';
import PanGestureHandler from './handlers/PanGestureHandler';
import PinchGestureHandler from './handlers/PinchGestureHandler';
import RotationGestureHandler from './handlers/RotationGestureHandler';
import TapGestureHandler from './handlers/TapGestureHandler';
export const Gestures = {
  NativeViewGestureHandler,
  PanGestureHandler,
  TapGestureHandler,
  LongPressGestureHandler,
  PinchGestureHandler,
  RotationGestureHandler,
  FlingGestureHandler,
  ManualGestureHandler,
  HoverGestureHandler
};
//# sourceMappingURL=Gestures.js.map